function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.928 10.98A2.727 2.727 0 006 10.183H4.364V14h4.363v-1.091c0-.723-.287-1.417-.799-1.928zM6.678 3.504a3.273 3.273 0 00-2.314-.959v6.546a3.273 3.273 0 002.314-5.587z",
  fill: "#DFDFDF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.799 10.98a2.727 2.727 0 011.928-.798h1.637V14H0v-1.091c0-.723.287-1.417.799-1.928zM2.05 3.504a3.273 3.273 0 012.314-.959v6.546a3.273 3.273 0 01-2.315-5.587z",
  fill: "#F7C945"
});

var SvgFindIconHalf = function SvgFindIconHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgFindIconHalf;